import { Injectable } from '@angular/core';
import { ImmutableContext } from '@ngxs-labs/immer-adapter';
import { Action, Selector, State, StateContext, Store } from '@ngxs/store';
import { DialpadNumberChangedAction } from '../../../../../samwin/client-phone/client-phone.actions';
import { CurrentNumberChanged } from './call-control-behaviour.actions';

export interface CallControlBehaviourInstance {
   currentNumber: string;
}

function getDefaultCallControlBehaviour(): CallControlBehaviourInstance {
   return {
      currentNumber: '',
   };
}

export interface CallControlBehaviourStateModel {
   [brickInstanceId: string]: CallControlBehaviourInstance;
}

@State<CallControlBehaviourStateModel>({
   name: 'callControlBehaviour',
   defaults: {},
})
@Injectable()
export class CallControlBehaviourState {
   constructor(private store: Store) {}

   private static getSpecificBehaviourStateOrDefaultInternal(state: CallControlBehaviourStateModel, brickInstanceId: string): CallControlBehaviourInstance {
      return state[brickInstanceId] ?? getDefaultCallControlBehaviour();
   }

   @Selector([CallControlBehaviourState])
   public static getCurrentNumberFn(state: CallControlBehaviourStateModel): (brickInstanceId: string) => string {
      return (brickInstanceId: string) => {
         return CallControlBehaviourState.getSpecificBehaviourStateOrDefaultInternal(state, brickInstanceId).currentNumber;
      };
   }

   @Action(CurrentNumberChanged)
   @ImmutableContext()
   public currentNumberChanged(ctx: StateContext<CallControlBehaviourStateModel>, action: CurrentNumberChanged) {
      ctx.setState((state: CallControlBehaviourStateModel) => {
         const ccState = CallControlBehaviourState.getSpecificBehaviourStateOrDefaultInternal(state, action.brickInstanceId);
         ccState.currentNumber = action.newNumber;
         state[action.brickInstanceId] = ccState;
         return state;
      });

      this.store.dispatch(new DialpadNumberChangedAction(action.newNumber, action.brickInstanceId, true));
   }
}
